import { render, staticRenderFns } from "./SwitchTypeStep.htm?vue&type=template&id=01bce6be&scoped=true&"
import script from "./SwitchTypeStep.ts?vue&type=script&lang=js&"
export * from "./SwitchTypeStep.ts?vue&type=script&lang=js&"
import style0 from "./SwitchTypeStep.scss?vue&type=style&index=0&id=01bce6be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bce6be",
  null
  
)

export default component.exports